import { useState, useContext } from 'react';
import { AuthContext } from '../../services/authContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-8685c875a9/icons';
import { Link, useNavigate } from 'react-router-dom';
import routes from '../../routes';
import '../../scss/components/navbar.scss';

const Navbar = ({ showNotificationIcon, setShowNotificationIcon }) => {
    const { logout } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };


    const handleLiveChatClick = () => {
        setShowNotificationIcon(false); // this now comes from props
    };


    return (
        <div id="Navbar">
            <div className={`menu ${isOpen ? 'open' : ''}`}>
                <ul className="mb-0 menuToggle">
                    <li className="menu__item" onClick={toggleMenu}>
                        <span className="toggleNavbarBtn">
                            <span className="menu__item__icon">
                                <FontAwesomeIcon icon={byPrefixAndName.fas['bars']} />
                            </span>
                            <span className="menu__item__text">Menu</span>
                        </span>
                    </li>
                </ul>
                <ul>
                    {routes
                        .filter(route => !route.hidden)
                        .map(({ path, name, icon }) => (
                            <li key={path} className="menu__item">
                                <Link
                                    to={path}
                                    onClick={path === '/liveChat' ? handleLiveChatClick : undefined}
                                >
                                    <span className="menu__item__icon">
                                        <FontAwesomeIcon icon={byPrefixAndName.fas[icon]} />
                                        {path === '/liveChat' && showNotificationIcon && (
                                            <span className="menu__item__notification-dot"></span>
                                        )}
                                    </span>
                                    <span className="menu__item__text">{name}</span>
                                </Link>
                            </li>
                        ))}

                </ul>
                <ul className="logout">
                    <li className="menu__item" onClick={handleLogout}>
                        <span className="logoutNavbarBtn">
                            <span className="menu__item__icon">
                                <FontAwesomeIcon icon={byPrefixAndName.fas['right-from-bracket']} />
                            </span>
                            <span className="menu__item__text">Log Out</span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    );
};


export default Navbar;
